import React from 'react';

import ArchiveRecordLabel from 'archive/components/ArchiveRecordLabel';
import BenchlingConfig from 'BenchlingConfig';
import {Grid, ParentStorableData, StorableSummary} from 'constants/SampleConstants';
import {getPossibleEditBarcodesDisabledError, getPossibleEditNamesDisabledError} from 'samples/SampleUtil';
import ParentStorableDetails from 'samples/storables/ParentStorableDetails';
import InlineField from 'ui-library/fields/InlineField';
import EditableTextField from 'ui-library/inputs/EditableTextField';

import BarcodeValue, {BarcodeValueProps} from '../BarcodeValue';
import * as StorableActions from '../StorableActions';
import GridToolbar from './GridToolbar';

interface Props {
  folderId: string | null;
  grid: Grid;
  parentStorable: StorableSummary | null;
}

class GridHeader extends React.Component<Props> {
  private handleSetParentStorable = (
    parentStorableData: ParentStorableData,
    // Event group id is not passed from the frontend for analytics. One will be created on the backend.
    _?: string,
    onFinish?: (errorMessage?: string) => void
  ): void => {
    StorableActions.updateGridWithDataMods(
      this.props.grid.id,
      this.props.folderId,
      {parentStorableData},
      onFinish
    );
  };

  private handleUpdateName = (name: string): void => {
    StorableActions.updateGridWithDataMods(this.props.grid.id, this.props.folderId, {name});
  };

  private handleUpdateBarcode = (barcode: string): void => {
    StorableActions.updateGridWithDataMods(this.props.grid.id, this.props.folderId, {barcode});
  };

  private getBarcodeValueProps = (): BarcodeValueProps => {
    if (!BenchlingConfig.INVENTORY_ENABLE_EDIT_BARCODES) {
      return {storable: this.props.grid};
    }
    return {
      storable: this.props.grid,
      isDisabled: !this.props.grid.permissions.canEditBarcodes,
      handleBarcodeChange: this.handleUpdateBarcode,
      disableEditsWithTooltip: getPossibleEditBarcodesDisabledError(
        this.props.grid.permissions.canEditBarcodes
      ),
    };
  };

  render(): JSX.Element {
    return (
      <div className="gridHeader">
        <div className="u-lr-split">
          <div className="gridHeader-title">
            <EditableTextField
              isDisabled={!this.props.grid.permissions.canEditNamesAndBarcodes}
              requestChange={this.handleUpdateName}
              value={this.props.grid.name}
              disableEditsWithTooltip={getPossibleEditNamesDisabledError(
                this.props.grid.permissions.canEditNamesAndBarcodes
              )}
              dataTestAttrs={{
                component: 'GridHeader',
                element: 'nameField',
              }}
            />
            <ArchiveRecordLabel item={this.props.grid} />
          </div>
          <GridToolbar grid={this.props.grid} onSetParentStorable={this.handleSetParentStorable} />
        </div>
        <InlineField label="Barcode">
          <BarcodeValue {...this.getBarcodeValueProps()} />
        </InlineField>
        {this.props.parentStorable && (
          <InlineField label="Location">
            <ParentStorableDetails
              isWritable={this.props.grid.permissions.writable}
              onSetParentStorable={this.handleSetParentStorable}
              parentStorable={this.props.parentStorable}
            />
          </InlineField>
        )}
      </div>
    );
  }
}

export default GridHeader;
